<template>
  <div class="out_wrapper">
    <div class="header_wrapper">
      <div class="header">
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="logo">
              <img src="@/assets/images/logo.png" alt="" />
            </div>
          </el-col>
          <el-col :span="12">
            <ul class="top_nav">
              <li><a href="http://ncfiva.com/" target="_blank">学校官网</a></li>
              <li>
                <a href="http://www.ncfiva.com/" target="_blank">招生信息</a>
              </li>
              <li>
                <a href="http://zs.ncfiva.com/" target="_blank">单招报名</a>
              </li>
               <li>
                <a href="http://school.duzhitech.cn/web/unified_search" target="_blank">统招录取查询</a>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="banner no-print">
      <div class="banner_txt">明德强技 实干笃学</div>
    </div>
    <div class="out_main">
      <el-divider content-position="left">录取查询</el-divider>
      <div class="form_wrapper">
        <el-form :model="user" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item prop="Name">
            <el-input type="text" v-model="user.Name" prefix-icon="el-icon-user" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item prop="CardNumber">
            <el-input type="text" v-model="user.CardNumber" prefix-icon="el-icon-document-copy" placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 100%" type="primary" @click="handleSearch(ruleForm)">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="form_con" style="text-align:center">
        录取信息暂未公布
      </div> -->
      <div class="form_con">
        <div v-if="score" class="search_wrapper">
          <div class="search_state">
            <span v-if="score.IsAdmission">
              <i class="el-icon-success"></i> 恭喜你!
              {{ score.StudentName }}同学，你以优异的成绩被录取成功了！
            </span>
            <span v-else>
              <i class="el-icon-error"></i> 很遗憾！，{{
                score.StudentName
              }}同学，你没有被录取，请再接再厉！
            </span>
          </div>
          <div class="search_top">以下是您的录取信息:</div>
          <div class="search_info">
            <div class="search_item">
              <div class="search_title">姓名：</div>
              <div class="search_con">{{ score.StudentName }}</div>
            </div>
            <div class="search_item" v-if="score.IsAdmission">
              <div class="search_title">录取专业：</div>
              <div class="search_con">{{ score.MajorName }}</div>
            </div>
            <div class="search_item">
              <div class="search_title">报考专业：</div>
              <div class="search_con">{{ score.SignMajorName }}</div>
            </div>
            <div class="search_item">
              <div class="search_title">语文：</div>
              <div class="search_con">{{score.Chinese}}</div>
            </div>
            <div class="search_item">
              <div class="search_title">英语：</div>
              <div class="search_con">{{score.English}}</div>
            </div>
            <div class="search_item">
              <div class="search_title">数学：</div>
              <div class="search_con">{{score.Mathematics}}</div>
            </div>
            <div class="search_item">
              <div class="search_title">技能总分：</div>
              <div class="search_con">{{score.Interview}}</div>
            </div>
            <div class="search_item">
              <div class="search_title">文化总分：</div>
              <div class="search_con">{{ score.Chinese + score.English+score.Mathematics}}</div>
            </div>
            <div class="search_item">
              <div class="search_title">总成绩：</div>
              <div class="search_con">{{ score.Total}}</div>
            </div>
            <div class="search_item">
              <div class="search_title">备注：</div>
              <div class="search_con" v-if="score.ExpressNumber">
                你的录取通知书已送出！快递单号是：{{ score.ExpressNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-notice">
        <p>
          1.拟录取考生名单于4月10日—4月14日在我校网站（http://zs.duzhitech.cn/）公示。拟录取考生名单在学校网站首页公示5天，接受社会监督如有疑问，请拨打电话0817-2603636咨询。
        </p>
        <p>
          2.预录取考生若要放弃本次预录取资格，考生本人在公示期5天内持准考证、身份证以及考生及家长签字的《放弃录取申请》原件到学校招生就业处办理相关手续。
        </p>

      </div>

      <div class="table-list">
        <el-collapse>
          <el-collapse-item title="点击查看公示名单">
            <el-table v-if="tableData" :data="tableData" stripe style="width: 100%">
              <el-table-column prop="Number" label="考生号" width="180">
              </el-table-column>
              <el-table-column prop="Name" label="姓名" width="180">
              </el-table-column>
              <el-table-column prop="CardNumber" label="身份证号">
              </el-table-column>
              <el-table-column prop="MajorName" label="录取专业">
              </el-table-column>
              <el-table-column prop="Type" label="录取类别">
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <my-footer class="no-print"></my-footer>
  </div>
</template>

<script lang="ts">
// import { } from "@ant-design/icons-vue";
import myFooter from "@/views/layout/footer.vue";
import { defineComponent, toRefs, ref, reactive } from "vue";
import useWrapper from "./useScoreSearch";
import { scopePublishApi } from "@/api/common";
// import { useRoute } from "vue-router";
export default defineComponent({
  name: "",
  components: {
    myFooter,
  },
  setup() {
    //*********** definning variables start **********//
    const { rawData, scopeSearch } = useWrapper();
    const ruleForm = ref<HTMLElement | null>(null);
    let tableData = reactive({
      tableData: [],
    });
    //*********** definning variables end **********//
    //*********** initData start **********//
    getScopePublish();
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//

    function handleSearch(ruleForm: any) {
      ruleForm.validate((valid: any) => {
        if (valid) {
          scopeSearch();
        } else {
          return false;
        }
      });
    }

    function getScopePublish() {
      scopePublishApi({ Keywords: "", PageIndex: 1, PageSize: 3000 }).then(
        (res: any) => {
          tableData.tableData = res.contents;
        }
      );
    }
    //*********** DOM FUN end **********//
    return {
      ...toRefs(rawData),
      handleSearch,
      ruleForm,
      ...toRefs(tableData),
    };
  },
});
</script>
<style lang="scss">
.out_wrapper {
  background: #fafafa;
  width: 100%;
  .header {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0;
    .logo {
      padding-top: 10px;
    }
    .logo img {
      height: 60px;
    }
    .top_nav li {
      float: left;
      padding: 30px 20px;
    }
    .top_nav li a {
      font-size: 18px;
      color: #666;
      &:hover {
        color: #c82434;
      }
    }
    .top_other {
      padding: 20px 0;
      ul {
        display: flex;
        justify-items: center;
        align-items: center;
      }
    }
    .top_other li {
      color: #999;
      cursor: pointer;
      padding-right: 10px;
    }
    .top_other li:nth-child(2) {
      border-right: 1px solid #ccc;
    }
    .top_other li:nth-child(3) {
      padding-left: 15px;
    }
  }
  .banner {
    height: 150px;
    width: 100%;
    background: url(../../assets/images/banner.png) #1890ff bottom no-repeat;
    color: #fff;
    font-size: 36px;
    font-weight: bold;
    padding-top: 50px;
    box-sizing: border-box;
    .banner_txt {
      width: 1200px;
      margin: 0 auto;
    }
  }
  .my_main {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
    background: #fafafa;
  }
  .el-footer {
    padding: 0;
  }
  .out_main {
    width: 1000px;
    padding: 20px;
    background: #fff;
    min-height: 500px;
    margin: 20px auto;
    border-radius: 5px;
    .form_wrapper {
      width: 400px;
      margin: 20px auto;
    }
  }
}
.search_state {
  text-align: center;
  color: #666;
  font-weight: bold;
  font-size: 20px;
  margin-top: 40px;
  .el-icon-success {
    color: #67c23a;
  }
  .el-icon-error {
    color: #f56c6c;
  }
}
.search_top {
  width: 600px;
  margin: 0 auto;
  padding: 20px 0;
  color: #666;
}
.search_info {
  border: 1px solid #f1f1f1;
  width: 600px;
  font-size: 14px;
  border-bottom: none;
  margin: 0 auto;

  .search_item {
    border-bottom: 1px solid #f1f1f1;
    line-height: 3;
    display: flex;
    font-size: 14px;
    .search_title {
      flex: 0 0 100px;
      padding: 0 10px;
      text-align: right;
      border-right: 1px solid #f1f1f1;
      color: #333;
    }
    .search_con {
      padding: 0 10px;
      color: #666;
    }
  }
  
}
.text-notice{width: 80%; margin: 30px auto;}
.text-notice p{text-indent: 2em; font-size: 16px; color: #666; line-height: 2; }
</style>
